var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"closeButton",on:{"click":function($event){return _vm.setModalVisible()}}},[_c('img',{attrs:{"src":require("@/assets/images/admin/Cancel.svg"),"width":"25px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }